import { Button, Spin } from "antd";
import { useNavigate } from "react-router-dom";
import { useGetSubscriptions } from "../../api/api.get";

export default function SubscriptionsSuccessPage() {
  const navigate = useNavigate();
  const { data: subscriptionsData, isLoading } = useGetSubscriptions();

  return (
    <div className="min-h-screen mx-auto max-w-5xl">
      <section className="my-12 py-8 px-4 sm:px-6 mb-10 lg:px-8 bg-gradient-to-r from-green-200 to-green-50 border-b border-slate-200">
        {isLoading && <Spin size="large" />}
        {subscriptionsData && (
          <div className="">
            <div className="bg-white rounded-2xl border border-slate-200 p-8 shadow-md">
              <h2 className="text-2xl font-bold text-foreground mb-2 flex gap-2">
                <img src="/assets/checked.png" alt="success-image" width={30} />
                Congratulations!
              </h2>
              <p className="text-muted-foreground mb-6">
                <span className="font-semibold text-slate-900">
                  Your subscription has been successfully activated.
                </span>
              </p>

              <div>
                <Button
                  onClick={() => navigate(`/subscriptions`)}
                  type="primary"
                >
                  Continue
                </Button>
              </div>
            </div>
          </div>
        )}
      </section>
    </div>
  );
}
